module.exports = __webpack_public_path__ + "site/img/team_banner.2265286c.jpg";